import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
var decodeJWT = function (token) {
    try {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window
            .atob(base64)
            .split('')
            .map(function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); })
            .join(''));
        return JSON.parse(jsonPayload);
    }
    catch (e) {
        return null;
    }
};
export default function Header() {
    var navigate = useNavigate();
    var _a = useState('User'), userName = _a[0], setUserName = _a[1];
    useEffect(function () {
        var token = localStorage.getItem('token'); // or useContext/Auth hook
        if (token) {
            var decoded = decodeJWT(token); // or fetch from API if token doesn't include user info
            if ((decoded === null || decoded === void 0 ? void 0 : decoded.name) || (decoded === null || decoded === void 0 ? void 0 : decoded.username)) {
                setUserName(decoded.name || decoded.username);
            }
        }
    }, []);
    return (_jsxs("header", { className: 'w-full bg-white shadow-sm px-4 py-2 flex items-center justify-between mb-4', children: [_jsx("div", { className: 'flex-1' }), _jsx("div", { className: 'flex items-center gap-4', children: _jsx("div", { className: 'w-10 h-10 rounded-full overflow-hidden border-2 border-primary', children: _jsx("img", { src: "https://ui-avatars.com/api/?name=".concat(encodeURIComponent(userName), "&background=e1e1e1"), alt: 'Profile', className: 'w-full h-full object-cover' }) }) })] }));
}
